import { pad, parseUtcTime } from '@/libs/app';
import React, { useEffect, useState } from 'react';
type CountDownType = {
  endTime: string;
  handleCountDown?: () => void;
};
export const CountDown = ({ endTime, handleCountDown }: CountDownType) => {
  const countDownDate = new Date(endTime).getTime();
  const [minute, setMinute] = useState<string>('--');
  const [second, setSecond] = useState<string>('--');
  useEffect(() => {
    let distance = 0;
    const interval = setInterval(() => {
      var now = parseUtcTime();
      distance = countDownDate - now;
      setMinute(pad(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))));
      setSecond(pad(Math.floor((distance % (1000 * 60)) / 1000)));

      if (Math.round(distance / 1000) < 1) {
        clearInterval(interval);
        handleCountDown && handleCountDown();
        // router.reload();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownDate, endTime, handleCountDown]);
  return (
    <>
      <span>{`${minute}:${second}`}</span>
    </>
  );
};
